import { emptySplitApi as api } from "./emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPlayList: builder.query<[], void>({
      query: () => {
        return {
          url: `/api/playlist/submittedPlaylists`,
        };
      },
    }),
     getPlayListNew: builder.query<
      any,
      {
        userId?: string;
        trackId?: string;
        genre?: string;
        country?: string;
        playlistName?: string;
        sortBy?: string;
        matchAll?: any;
        allowAITracks?: boolean;
      }
    >({
      query: ({ userId, trackId, genre, country, playlistName, sortBy, matchAll, allowAITracks }) => {
        const params: Record<string, any> = {};

        if (userId) params.userId = userId;
        if (trackId) params.trackId = trackId;
        if (genre && genre !== "none") params.genre = genre; // 👈 only include genre if it's not "none"
        if (country) params.country = country;
        if (playlistName) params.playlistName = playlistName;
        if (sortBy) params.sortBy = sortBy;
        if (matchAll !== undefined) params.matchAll = matchAll;
        if (allowAITracks !== undefined) params.allowAITracks = allowAITracks;

        return {
          url: "/api/playlist/submitted",
          params,
        };
      },
    }),

    getTopFollowerPlaylists: builder.query<[], void>({
      query: () => {
        return {
          url: `/api/playlist/top-followers-playlists`,
        };
      },
    }),

    getPlayListDetail: builder.query<any, Partial<PlaylistApiArg>>({
      query: (queryArg) => {
        return {
          url: `/api/playlist/playlist-detail`,
          params: queryArg,
        };
      },
    }),
    getPlayListById: builder.query<any, Partial<PlaylistApiArg>>({
      query: (queryArg) => {
        return {
          url: `/api/playlist`,
          params: queryArg,
        };
      },
    }),
    getUserCountries: builder.query<any, Partial<PlaylistApiArg>>({
      query: (queryArg) => {
        return {
          url: `/api/playlist/user-countries`,
          params: queryArg,
        };
      },
    }),
    createPlaylist: builder.mutation<any, PlaylistApiArg>({
      query: (queryArg) => {
        return {
          url: `/api/playlist`,
          method: "POST",
          body: queryArg,
        };
      },
    }),
    updatePlayList: builder.mutation<any, Partial<PlaylistApiArg>>({
      query: (queryArg) => {
        return {
          url: `/api/playlist/status`,
          method: "PUT",
          body: queryArg,
        };
      },
    }),
    deletePlayList: builder.mutation<any, Partial<PlaylistApiArg>>({
      query: (queryArg) => {
        return {
          url: `/api/playlist/update`,
          method: "PUT",
          body: queryArg,
        };
      },
    }),
    pinPlaylist: builder.mutation<any, { playlistId: string }>({
      query: (queryArg) => {
        return {
          url: `/api/playlist/pin`,
          method: "PUT",
          body: queryArg,
        };
      },
    }),
    genreReport: builder.mutation<any, GenreReportArg>({
      query: (body) => ({
          url: `/api/genre-mismatch/report-genre-mismatch`,
          method: "POST",
          body,
      }),
    }),
  }),
});
export { injectedRtkApi as enhancedApi };

export type PlaylistApiArg = {
  playlistId?: string;
  genres?: any;
  userId?: any;
  genre?:any;
  country?: any;
  playlistName?: any;
  sortBy?: string;
  matchAll?: any;
  status?: any;
  trackId?: any;
  uri?: any;
  declineReason?: any;
  id?: any;
  isActive?: any;
  submitConditions?: {
    followUserUrls?: any;
    followPlaylistUrls?: any;
    platformType?: String;
    saveTrackUrl?: String;
  }; 
};

export type GenreReportArg = {
  trackId: string;
  playlistId: string;
  status: "declined";
  userId: string;
};

export const {
  useCreatePlaylistMutation,
  useGetPlayListQuery,
  useGetPlayListNewQuery,
  useLazyGetPlayListNewQuery,
  useGetPlayListDetailQuery,
  useGetPlayListByIdQuery,
  useUpdatePlayListMutation,
  useDeletePlayListMutation,
  useGetUserCountriesQuery,
  useGetTopFollowerPlaylistsQuery,
  useGenreReportMutation,
  usePinPlaylistMutation,
} = injectedRtkApi;
